import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

/** Converte string "A,B" em array ['A', 'B'] */
export const parseStringToList = (v: unknown): string[] =>
  typeof v === 'string' ? v.split(',').filter(Boolean) : []

export const parseStringToDayjs = (v: unknown): Dayjs | null => {
  if (typeof v !== 'string' || !v) return null
  const d = dayjs(v)
  return d.isValid() ? d : null
}

export const parseDayjsToString = (d: Dayjs | null): string | undefined =>
  d && d.isValid() ? d.toISOString() : undefined
